import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	howToRead: {
		id: 'software-reports-report-page.header.chevron.how-to-read',
		defaultMessage: 'How to read this report',
		description: 'A subheading for a section describing how to read the current report',
	},
	hideHowToRead: {
		id: 'software-reports-report-page.header.chevron.hide-how-to-read',
		defaultMessage: 'Hide report help',
		description: 'Clickable text to hide the section describing how to read the current report',
	},
});
